import type { FC } from 'react';
import type React from 'react';
import { Button, Stack } from '@mui/material';

import { styles } from './index.styles';

export interface ButtonPanelProps {
  onClick: () => void;
  children?: React.ReactNode;
  dataTestId?: string;
}

const ButtonPanel: FC<ButtonPanelProps> = ({
  children,
  onClick,
  dataTestId,
}) => (
  <Button
    variant="text"
    disableRipple
    sx={styles.wrapper}
    onClick={onClick}
    data-test-id={dataTestId}
  >
    <Stack direction="row" spacing={2} sx={styles.content}>
      {children}
    </Stack>
  </Button>
);

export default ButtonPanel;
